import { render, staticRenderFns } from "./FTPCredentialForm.vue?vue&type=template&id=22a7b2c0&"
import script from "./FTPCredentialForm.vue?vue&type=script&lang=js&"
export * from "./FTPCredentialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a7b2c0')) {
      api.createRecord('22a7b2c0', component.options)
    } else {
      api.reload('22a7b2c0', component.options)
    }
    module.hot.accept("./FTPCredentialForm.vue?vue&type=template&id=22a7b2c0&", function () {
      api.rerender('22a7b2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/FTPCredentialForm.vue"
export default component.exports